import { BaseModule } from "./base.module";

export class GenericStateMachineEventsModule extends BaseModule {
    initialize() {
		document.addEventListener('scroll', () => {
			this.triggerEventOnElement('scrolling', document.documentElement);
		});

		window.addEventListener('resize', () => {
			this.triggerEventOnElement('viewport-resizing', document.documentElement);
		});
    }
}